import { Vector3 } from "../../../math/Vector3.js";
import { BodyMath } from "../../bodies/BodyMath.js";
import { SimpleRotationModel } from "../rotation/IAURotationModel.js";
import { CachedOrbit } from "./CachedOrbit.js";
class SunOrbit extends CachedOrbit {
    computePosition() {
        return Vector3.Zero();
    }
    getPeriod() {
        return 0; //0.4;
    }
    getBoundingRadius() {
        return 0;
    }
}
export function createSunBodyMath() {
    return new BodyMath(new SunOrbit(), new SimpleRotationModel(0, 90, 25.05, true), BodyMath.EclipticFrame);
}
